"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _imageService = require("./imageService");

var _imageService2 = _interopRequireDefault(_imageService);

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var FirebaseService = function (_ImageService) {
  _inherits(FirebaseService, _ImageService);

  function FirebaseService(_ref) {
    var dir = _ref.dir,
        hash = _ref.hash,
        filename = _ref.filename,
        firebase = _ref.firebase;

    _classCallCheck(this, FirebaseService);

    var _this = _possibleConstructorReturn(this, (FirebaseService.__proto__ || Object.getPrototypeOf(FirebaseService)).call(this));

    _this.dir = dir || "";
    _this.hash = Boolean(hash);
    _this.filename = filename || "";

    if (!firebase) {
      throw new Error("firebase client instance is required.");
    }

    _this.firebase = firebase;
    return _this;
  }

  _createClass(FirebaseService, [{
    key: "getServiceConfig",
    value: function getServiceConfig() {
      return {
        customRequest: function (obj) {
          var file = obj.file,
              onProgress = obj.onProgress,
              onSuccess = obj.onSuccess,
              onError = obj.onError;

          var _splitFilename = (0, _utils.splitFilename)(file.name),
              fileExtension = _splitFilename.fileExtension,
              nameWithoutExtension = _splitFilename.nameWithoutExtension;

          var filename = this.filename || nameWithoutExtension;

          if (this.hash) {
            var hash = (0, _utils.randomString)();
            filename = filename + "-" + hash + "." + fileExtension;
          } else {
            filename = filename + "." + fileExtension;
          }

          var images = this.firebase.storage().ref(this.dir || "").child(filename);
          var uploadTask = images.put(file);
          uploadTask.on(this.firebase.storage.TaskEvent.STATE_CHANGED, function (snapshot) {
            var percent = snapshot.bytesTransferred / snapshot.totalBytes * 100;
            onProgress({
              percent: percent
            });
          }, function (e) {
            onError(e);
          }, function () {
            uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
              onSuccess({
                data: {
                  link: downloadURL
                }
              });
            });
          });
        }.bind(this)
      };
    }
  }]);

  return FirebaseService;
}(_imageService2.default);

exports.default = FirebaseService;